import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import NavBar from "./components/navbar/NavBar";
import Header from "./components/header/Header";
import About from "./components/about/About";
import Projects from "./components/projects/Projects";
import Partners from "./components/partners/Partners";
import Footer from "./components/footer/Footer";
import Contact from "./pages/contact/Contact"; // Uncomment if you have a Contact component

function App() {
  return (
    <Router>
      <>
        <NavBar />
        <div id="home">
          <Header />
        </div>
        <div id="about">
          <About />
        </div>
        <div id="projects">
          <Projects />
        </div>
        <div id="partners">
          <Partners />
        </div>
        {/* Uncomment this if you have a Contact section */}
        <div id="contact">
          <Contact />
        </div>
        <Footer />
      </>
    </Router>
  );
}

export default App;
